import React, { Component } from 'react'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { fetchForgotPasswordUser } from '../modules/forgotPassword'
import { LoadingIndicator } from '../components/loadingIndicator';
import Messages from '../constants/messages'
import ForgotPasswordResetForm from '../components/forgotPasswordResetForm'
import withStyles from 'material-ui/styles/withStyles'
import { Typography } from 'material-ui';

const styles = theme => ({
  center: {
    textAlign: 'center'
  },
  content: {
    fontSize: '1em',
    paddingBottom: '1em'
  }
})

class ForgotPassword extends Component {
  componentDidMount() {
    const { fetchForgotPasswordUser, initialValues, userId } = this.props
    if (!initialValues.email) {
      fetchForgotPasswordUser(userId)
    }
  }

  renderCompleted() {
    const { classes } = this.props
    return (
      <div data-test-id="resetCompletePage" className={classes.center}>
        {Messages['pageMessages']['PASSWORD_CHANGED_MSG']}
      </div>
    )
  }

  renderMissing() {
    const { classes } = this.props
    return (
      <div data-test-id="missingSecurityQuestionPage">
      <Typography className={classes.content}>
        {Messages['pageMessages']['SECURITY_QUESTION_MISSING_MSG']}
      </Typography>
      <Typography className={classes.content}>
        {Messages['pageMessages']['SECURITY_QUESTION_REMINDER_MSG']}
      </Typography>
      </div>
    )
  }

  render() {
    const { classes, completed, hasReceivedUserInfo, partner, securityQuestion, userId } = this.props
    let renderContents = this.renderMissing()
    if (!hasReceivedUserInfo) {
      renderContents = <LoadingIndicator classes={classes} infoText={Messages['uiComponents']['LOADING_MSG']} />
    } else if (completed) {
      renderContents = this.renderCompleted()
    } else if (securityQuestion) {
      renderContents = <ForgotPasswordResetForm userId={userId} partner={partner} />
    }
    return (
      renderContents
    )
  }
}

const mapStateToProps = state => ({
  completed: state.forgotPassword.completed,
  initialValues: state.forgotPasswordResetForm.initialValues,
  hasReceivedUserInfo: state.forgotPassword.hasReceivedUserInfo,
  partner: state.forgotPassword.partner,
  securityQuestion: state.forgotPassword.securityQuestion,
  userId: state.forgotPassword.userId
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchForgotPasswordUser
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ForgotPassword)